/**
 * Readonly-input-styled service-account email, sitting inline inside the
 * "Events Attachments" copy (ExplainerCard + scopeDefinitions' shared scope
 * description) — the address needs to be pasted into a calendar-sharing
 * dialog elsewhere, so it's rendered as a standalone field with a copy
 * button rather than plain inline text.
 */
import React from "react";
import appConfig from "../../../../appConfig";
import CopyButton from "../OrgSettings/CustomDomainPage/CopyButton";
import styles from "./ServiceAccountEmailField.module.scss";

const ServiceAccountEmailField = () => (
  <span className={styles.field}>
    <span className={styles.value}>{appConfig.serviceAccountEmail}</span>
    <CopyButton value={appConfig.serviceAccountEmail} />
  </span>
);

export default ServiceAccountEmailField;
